const initGalleryFilter = (sliderBlock) => {
    const wrap = sliderBlock.querySelector('#gallery-filter');
    const slides = sliderBlock.querySelector('#gallery-slides');
    const globals = window.GalleryFilter;
    if (!wrap || !slides || !globals) return;

    const allowed = slides.dataset.allowed || '';
    const filterLinks = wrap.querySelectorAll('.gallery-filter-link');

    // set “All” active on load
    const allLink = wrap.querySelector('.gallery-filter-link[data-term="0"]');
    if (allLink) allLink.classList.add('active');

    wrap.addEventListener('click', (e) => {
		const link = e.target.closest('.gallery-filter-link');
		if (!link || !wrap.contains(link)) return;
		e.preventDefault();

		filterLinks.forEach((a) => a.classList.remove('active'));
		link.classList.add('active');

		const term = link.dataset.term || 0;
		const body = new URLSearchParams();
		body.append('action', 'gallery_filter');
		body.append('nonce', globals.nonce);
		body.append('term', term);
		body.append('allowed', allowed);

		fetch(globals.ajaxUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
			body: body.toString(),
		})
			.then((r) => r.json())
				.then((resp) => {
				if (resp.success && resp.data?.html !== undefined) {
					slides.innerHTML = resp.data.html;
				}
		});
    });
};

document.querySelectorAll('.slider-gallery-block').forEach(initGalleryFilter);

export default initGalleryFilter;
